import { styled, Table } from '@healthinal/ui';
import { PATIENT_TABLE_CELL_HEIGHT, theme } from '../../../../theme.ts';

export const PatientTable = styled(Table)`
  --TableCell-height: ${PATIENT_TABLE_CELL_HEIGHT}px;
  width: 100%;
  min-width: max-content;
  table-layout: fixed;

  tbody tr {
    scroll-margin-top: ${PATIENT_TABLE_CELL_HEIGHT * 3}px;
    scroll-margin-bottom: ${PATIENT_TABLE_CELL_HEIGHT * 2}px;
    outline: none;
    &:first-of-type td,
    &:nth-last-of-type(2) td {
      border-color: ${theme.vars.palette.background.surface};
    }
  }
  td {
    vertical-align: center;
  }
`;
